<form id="czSurveyStepperForm" [formGroup]="czSurveyFormGroup" class="form">
  <mat-horizontal-stepper #surveyStepper *ngIf="survey && surveyStarted" 
                                         class="survey-stepper" 
                                         formArrayName="formArray"
                                         [linear]="true"
                                         (selectionChange)="stepperHeadClicked($event)">
    <ng-template matStepperIcon="edit">
      <img class="step-success" src="./assets/images/components/cz-assessment/icons/step-header-check.svg" />
    </ng-template>

    <!-- loop through pages -->
    <ng-container *ngFor="let page of survey.pages; let i = index">
      <mat-step [formGroupName]="i" [stepControl]="formArray.get([i])">
        <h1 class="step-header">{{ page.title }}</h1>
        <h5 *ngIf="page.subTitle" class="subtitle">{{ page.subTitle }}</h5>
        <ol>
          <!-- loop through questionGroups -->
          <div *ngFor="let questionGroup of page.questionGroups" class="row">
            <div *ngIf="questionGroup.id !== 'DC' && questionGroup.id !== 'EPIC'" class="col-xs-12">
              <!-- loop through questions -->
              <li *ngFor="let question of questionGroup.questions">
                <cz-dynamic-question-content [type]="questionGroup.id"
                                             [question]="question"
                                             [form]="formArray.get([i])"
                                             [imagePath]="surveyImagePath">
                </cz-dynamic-question-content>
              </li>
            </div>

            <!-- we don't want multiple body charts for this question group -->
            <div *ngIf="questionGroup.id === 'DC'" class="col-xs-12">
              <cz-discomfort-body-diagram [data]="questionGroup" [form]="formArray.get([i])"></cz-discomfort-body-diagram>
            </div>

            <!-- photo upload page -->
            <div *ngIf="questionGroup.id === 'EPIC'" class="col-xs-12">
              <h5 class="no-margin" [innerHTML]="'$photo_upload_photo_upload_introduction' | translate"></h5>
              <div class="section-image-uploading">
                <div class="col-xs-12">
                  <cz-photo-upload [placeholderImage]="placeholderImage"
                                   [parentComponent]="componentName"
                                   [questionGroup]="questionGroup"
                                   [form]="formArray.get([i])"
                                   [userId]="userId"
                                   [taskId]="taskId">
                  </cz-photo-upload>
                </div>
              </div>
            </div>
          </div>
        </ol>

        <div class="row">
          <div class="col-xs-2 col-xs-offset-7" *ngIf="i > 0">
            <button mat-button
                    color="accent"
                    matStepperPrevious
                    (click)="stepperClicked(null, false, i)" [innerHTML]="'$btn_back' | translate">
            </button>
          </div>
          <div class="end-xs" *ngIf="i < survey.pages.length - 1" [ngClass]="i === 0 ? 'col-xs-12' : 'col-xs-3'">
            <button mat-flat-button
                    color="accent"
                    matStepperNext
                    (click)="stepperClicked(formArray.get([i]), false, i)" [innerHTML]="'$btn_next' | translate">
            </button>
            <span class="required-notification"><span class="asterisk">*</span> <span [innerHTML]="'$common_required_field' | translate"></span></span>
          </div>
          <div class="col-xs-3 end-xs" *ngIf="i === survey.pages.length - 1">
            <button mat-flat-button
                    color="accent"
                    matStepperNext
                    (click)="stepperClicked(formArray.get([i]), true, i)" [innerHTML]="'$btn_finish' | translate">
            </button>
          </div>
        </div>
      </mat-step>
    </ng-container>
  </mat-horizontal-stepper>
</form>
